module.exports = __webpack_public_path__ + "static/assets/873eebe285f6ba91dea073ef795b1fb9.svg";